import React from 'react';

// ─── GCAL RECONNECT PROMPT ─────────────────────────────────────────────────────
// Shown when the Google Calendar token needs a real interactive reconnect —
// either right after a fresh sign-in, or on the rare occasion background
// silent renewal couldn't keep up (see lib/gcalAuth.js). Deliberately not
// styled as an error: this is routine, on-brand upkeep, not something
// broken.

export default function GCalReconnectPrompt({ onReconnect }) {
  return (
    <div className="gcal-reconnect">
      <img src="/grove-symbol.png" alt="" className="gcal-reconnect__icon" />
      <p className="gcal-reconnect__text">
        Your calendar's out of reach — reconnect to keep Grove growing.
      </p>
      <button className="btn btn--primary btn--sm" onClick={onReconnect}>
        Reconnect
      </button>
    </div>
  );
}
